<template>
  <div v-loading="loading || childLoading">
    <template v-if="treeDataSource.length <= 0">
      <el-alert
        title="Ops"
        :type="mensagemErro.erro ? 'error' : 'info'"
        :description="mensagemErro.msg"
        show-icon
      ></el-alert>
    </template>
    <tree-table ref="recTreeFluxo" :list.sync="treeDataSource" @handlerExpand="handlerExpand"></tree-table>
  </div>
</template>
<script>
import TreeTable from '@/components/TreeTableFluxoDeCaixa'
export default {
  props: {
    dataJson: { type: Object },
    mensagemErro: { type: Object }
  },
  data() {
    return {
      treeDataSource: [],
      loading: true,
      childLoading: true
    }
  },
  components: {
    TreeTable
  },
  watch: {
    dataJson: function(newData) {
      this.treeDataSource = newData;
      this.loading = false;
    }
  },
  methods: {
    handlerExpand(m) {
      m.isExpand = !m.isExpand
    }
  },
  created() {
    this.$root.$on("loading", val => {
      this.childLoading = val;
    });
  }
}
</script>
